type AgentSourceWithStatus = {
  response_status?: string | null;
};

export function filterDisplayableAgentSources<T extends AgentSourceWithStatus>(
  sources?: T[] | null,
): T[] {
  if (!Array.isArray(sources)) {
    return [];
  }

  return sources.filter((source) => source?.response_status !== "bad_request");
}
